export const getters = {
    getGrupoProduto: state => state.grupoProduto,
    getGruposProduto: state => state.gruposProduto,
    getModalCadastroGrupoProduto: state => state.modalCadastroGrupoProduto,
    getModalExcluirGrupoProduto: state => state.modalExcluirGrupoProduto
}

export default {}